import React, { useState, useEffect } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { get } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import Title from '../../components/common/Title/Title';
import AccordionItem from '../../components/common/AccordionItem/AccordionItem';
import styles from './FaqPage.module.css';
import {showBackButton} from "../../services/telegramService";

const FaqPage = () => {
    const [faqGroups, setFaqGroups] = useState([]);
    const { showPageLoader, hidePageLoader } = usePageLoader();

    useEffect(() => {
        showBackButton();
    }, []);

    useEffect(() => {
        showPageLoader();
        get('faqs')
            .then(response => {
                if (response.data) {
                    setFaqGroups(response.data);
                }
            })
            .catch(console.error)
            .finally(() => hidePageLoader());
    }, [showPageLoader, hidePageLoader]);

    return (
        <div>
            <Title><FormattedMessage id="faqPage.title" defaultMessage="Вопросы и Ответы" /></Title>

            {faqGroups.map(group => (
                <section key={group.category} className={styles.faqGroup}>
                    <h2 className={styles.categoryTitle}>{group.category}</h2>
                    <div className={styles.accordionContainer}>
                        {group.items.map(item => (
                            <AccordionItem
                                key={item.id}
                                question={item.question}
                                answer={item.answer}
                            />
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
};
export default FaqPage;
